import { OverviewHeader } from './OverviewHeader'
import { withOverviewHeader } from './withOverviewHeader'

const ConnectedOverviewHeader = withOverviewHeader(OverviewHeader)

export { ConnectedOverviewHeader as OverviewHeader }
